// 解析XML并提取图片URL列表
export async function fetchUrlSources(sourcePrefix) {
  try {
    const response = await fetch('https://objectstorageapi.hzh.sealos.run/rr4obpkh-private-dreaming')
    const xmlText = await response.text()
    
    // Parse XML
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml')
    
    // Extract all <Key> elements that match the prefix
    const keys = Array.from(xmlDoc.getElementsByTagName('Key'))
      .map(key => key.textContent)
      .filter(key => key.startsWith(sourcePrefix))
      .filter(key => !key.endsWith('_#'))
    
    // Convert keys to full URLs
    const urls = keys.map(key => 
      `https://objectstorageapi.hzh.sealos.run/rr4obpkh-private-dreaming/${key}`
    )
    
    return urls
  } catch (error) {
    console.error('Error fetching source URLs:', error)
    throw error
  }
} 